import * as feedCommands from './feed'
import { widgetLibraries } from 'init/command-queue'
import { CommentCaptureConfig as ICommentCaptureConfig } from 'services/api-service'
import { loadConfig } from './feed-comment-capture.config'
import trackingService from 'services/tracking-service'

export const type = 'feed-comment-capture'

export function loadWidget(widgetConfig: ICommentCaptureConfig): Promise<void> {
  return new Promise<void>((resolve) => {
    loadConfig(widgetConfig)
    widgetLibraries.feed = feedCommands
    resolve()
    trackingService.queueEvent('feed-comment-capture', 'load')
  })
}
